<div class="sub-nav-wrapper" *ngIf="isTeamEvent && containerDisplay !== 'EDITTEAM' && containerDisplay !== 'ADDTOFIELD'">
    <div class="sub-nav">
        <div class="sub-nav-item" [class.active]="containerDisplay === 'INDIVIDUAL'" (click)="containerDisplay = 'INDIVIDUAL'">Individuals</div>
        <div class="sub-nav-item" [class.active]="containerDisplay === 'TEAMS'" (click)="containerDisplay = 'TEAMS'">Teams</div>
    </div>
</div>

<app-add-to-field *ngIf="containerDisplay === 'ADDTOFIELD'" [league]="league" (playersAdded)="refreshField()"></app-add-to-field>

<div *ngIf="containerDisplay === 'EDITTEAM'">
    <app-create-team
        [league]="league"
        [paidPlayers]="playersForTeamForm"
        [teamToEdit]="teamToEdit"
        (saved)="refreshTeams()"
        (canceled)="cancelEditTeam()">
    </app-create-team>
</div>

<div id="individuals-container" *ngIf="containerDisplay === 'INDIVIDUAL'">
    <div class="table-container">
        <table>
            <thead>
                <tr>
                <th>Player</th>
                <th class="center">Paid</th>
                <th class="narrow" *ngIf="isEventAdmin"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let p of field">
                    <td>
                        {{ p.firstName }} {{ p.lastName }}
                    </td>
                    <td class="center">
                        <img class="has-paid-image" src="../../../../assets/noun-check-circle-6630733-71D358.png" *ngIf="p.hasPaid" />
                        <img class="has-paid-image" src="../../../../assets/noun-x-circle-4815624-FF001C.png" *ngIf="!p.hasPaid" />
                    </td>
                    <td class="narrow" *ngIf="isEventAdmin"><ui-switch [(ngModel)]="p.hasPaid" defaultBgColor="red" class="toggle-switch" (ngModelChange)="toggleHasPaid(p)"></ui-switch></td>
                </tr>
                <tr>
                    <td colspan="3">
                        <button (click)="containerDisplay='ADDTOFIELD'" *ngIf="canAddToField">Add Player to Field</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="!field || field.length === 0" class="empty-message">
            The field for this league is currently empty.
        </div>
    </div>
</div>

<div id="teams-container" *ngIf="containerDisplay === 'TEAMS'">
    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th>Team</th>
                    <th class="center narrow"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of teamRows">
                    <td>
                        <p>{{ row.team.teamName }}</p>
                        <p>
                            <span *ngFor="let teamPlayer of row.team.players; let isLast = last" class="team-player-name">{{ teamPlayer.firstName }} {{ teamPlayer.lastName }}<span *ngIf="!isLast">, </span></span>
                        </p>
                    </td>
                    <td class="center narrow team-actions">
                        <img
                            *ngIf="canEditTeam(row.team) && !row.isConfirmingDelete"
                            src="../../../../assets/noun-pencil-8209025-FFFFFF.png"
                            class="pencil"
                            (click)="editTeam(row.team)"
                        />
                        <ng-container *ngIf="isEventAdmin">
                            <img
                                *ngIf="!row.isConfirmingDelete"
                                src="../../../../assets/noun-trash-7207989-FFFFFF.png"
                                class="team-trash"
                                (click)="row.isConfirmingDelete = true"
                            />
                            <span *ngIf="row.isConfirmingDelete" class="delete-confirm">
                                <p>Delete team?</p>
                                <img src="../../../../assets/noun-check-circle-6630733-71D358.png" class="confirm-icon" (click)="deleteTeam(row)" />
                                <img src="../../../../assets/noun-x-circle-4815624-FF001C.png" class="confirm-icon" (click)="row.isConfirmingDelete = false" />
                            </span>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="!teams || teams.length === 0" class="empty-message">
            No teams have been created yet.
        </div>
    </div>
</div>
